var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#E3E6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5159 8.35557L12.1258 16.2968H9.91394L8.24562 9.95933C8.14434 9.56898 8.05627 9.42598 7.74823 9.26153C7.24531 8.99366 6.4148 8.74234 5.68408 8.58636L5.73371 8.35557H9.29409C9.74792 8.35557 10.1559 8.65217 10.2589 9.16526L11.14 13.7604L13.3176 8.35544L15.5159 8.35557ZM24.1823 13.704C24.1912 11.6081 21.2303 11.4926 21.2506 10.5564C21.257 10.2714 21.5333 9.96847 22.1382 9.89114C22.438 9.85261 23.2641 9.82321 24.201 10.2465L24.5685 8.56253C24.0651 8.38311 23.4173 8.21045 22.6113 8.21045C20.5431 8.21045 19.0876 9.28986 19.0754 10.8355C19.062 11.9787 20.1143 12.6167 20.907 12.9966C21.7226 13.3856 21.9962 13.6356 21.9931 13.9836C21.9873 14.5162 21.3426 14.7514 20.7402 14.7607C19.6885 14.7766 19.0782 14.4813 18.5917 14.2592L18.2125 15.999C18.7014 16.2192 19.6038 16.4113 20.5394 16.421C22.7376 16.421 24.1755 15.3549 24.1823 13.704ZM29.6436 16.2968H31.5788L29.8896 8.35557H28.1034C27.7018 8.35557 27.363 8.58517 27.213 8.93818L24.0732 16.2968H26.2703L26.7065 15.1106H29.391L29.6436 16.2968ZM27.3089 13.483L28.4102 10.5014L29.0441 13.483H27.3089ZM18.5056 8.35557L16.7753 16.2968H14.683L16.4139 8.35557H18.5056Z",
    fill: "#1434CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.377af18228a54472e5bbb83df613e9e7.svg";
export { ForwardRef as ReactComponent };